// extracted by mini-css-extract-plugin
export default {"card_shadow":"pfi_coupon_section_card_shadow__Q35Vs","gradient_text":"pfi_coupon_section_gradient_text__AZaxw"};